/**
 * Uygulama yapılandırma dosyası
 */

// api urlleri
export const API_URL = 'https://api.bikuyum.com/api';

// api url değişme fonk
export const setApiUrl = (newUrl) => {
    if (typeof window !== 'undefined') {
        localStorage.setItem('api_url', newUrl);
        console.log(`API URL değiştirildi: ${newUrl}`);
    }
};

// güncel api alma fonk
export const getApiUrl = () => {
    if (typeof window !== 'undefined') {
        const savedUrl = localStorage.getItem('api_url');
        return savedUrl || API_URL;
    }
    return API_URL;
};

// api url'i localStorage'dan silme fonk
export const clearApiUrl = () => {
    if (typeof window !== 'undefined') {
        localStorage.removeItem('api_url');
        console.log('API URL localStorage\'dan silindi');
    }
}; 